import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, Stack, Typography, Box, Alert, List, ListItem, ListItemText, Paper, Card, CardMedia, CardContent, CardActions, IconButton, Menu, MenuItem, Select, FormControl, InputLabel, TextField, FormControlLabel, Checkbox } from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import ImageUploading from "react-images-uploading";
import AnnonceContext from "../../../../../contexts/AnnonceContext";
import { notifySuccess, notifyErrorEmpty } from 'src/service/notificationService';
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { analyzeImage } from 'src/service/visionApi';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import { getCategories } from 'src/service/categoriesApi';
import { getMappings, sendResultsToMappingAPI } from 'src/service/mappingApi';

/**
 * Exemple de structure JSON d'une catégorie
 * {
 *   "id": 4,
 *   "name": "Smartphone",
 *   "attribute": [
 *     {
 *       "id": 1,
 *       "name": "type",
 *       "parent_id": null,
 *       "uiLabel": "Type",
 *       "ui": "select",
 *       "isSecret": false,
 *       "isRequired": true,
 *       "uiValue": null
 *     },
 *     {
 *       "id": 2,
 *       "name": "marque",
 *       "parent_id": null,
 *       "uiLabel": "Marque",
 *       "ui": "select",
 *       "isSecret": false,
 *       "isRequired": true,
 *       "uiValue": null
 *     },
 *     {
 *       "id": 3,
 *       "name": "état",
 *       "parent_id": null,
 *       "uiLabel": "État",
 *       "ui": "select",
 *       "isSecret": false,
 *       "isRequired": true,
 *       "uiValue": null
 *     },
 *     {
 *       "id": 4,
 *       "name": "couleur",
 *       "parent_id": null,
 *       "uiLabel": "Couleur",
 *       "ui": "colorcheckbox",
 *       "isSecret": false,
 *       "isRequired": true,
 *       "uiValue": null
 *     },
 *     {
 *       "id": 5,
 *       "name": "écran cassé",
 *       "parent_id": 3,
 *       "uiLabel": "Écran cassé",
 *       "ui": "checkbox",
 *       "isSecret": false,
 *       "isRequired": false,
 *       "uiValue": "Écran cassé"
 *     },
 *     {
 *       "id": 6,
 *       "name": "écran intact",
 *       "parent_id": 3,
 *       "uiLabel": "Écran intact",
 *       "ui": "checkbox",
 *       "isSecret": false,
 *       "isRequired": false,
 *       "uiValue": "Écran intact"
 *     },
 *     {
 *       "id": 7,
 *       "name": "iphone",
 *       "parent_id": 2,
 *       "uiLabel": "iPhone",
 *       "ui": "select",
 *       "isSecret": false,
 *       "isRequired": false,
 *       "uiValue": "iPhone"
 *     },
 *     {
 *       "id": 8,
 *       "name": "samsung",
 *       "parent_id": 2,
 *       "uiLabel": "Samsung",
 *       "ui": "select",
 *       "isSecret": false,
 *       "isRequired": false,
 *       "uiValue": "Samsung"
 *     }
 *   ]
 * }
 */

// Mapping des catégories Vision API vers nos catégories
const visionToCategoryMapping = {
  // Doudous / Peluches (ID: 19)
  'teddy bear': { id: 19, name: 'Doudous / Peluches' },
  'stuffed animal': { id: 19, name: 'Doudous / Peluches' },
  'plush toy': { id: 19, name: 'Doudous / Peluches' },
  'toy': { id: 19, name: 'Doudous / Peluches' },
  'doll': { id: 19, name: 'Doudous / Peluches' },

  // Smartphone (ID: 4)
  'cellular telephone': { id: 4, name: 'Smartphone' },
  'mobile phone': { id: 4, name: 'Smartphone' },
  'smartphone': { id: 4, name: 'Smartphone' },

  // Vêtements (ID: 5)
  'jacket': { id: 5, name: 'Vêtements' },
  'coat': { id: 5, name: 'Vêtements' },
  'shirt': { id: 5, name: 'Vêtements' },
  'sweater': { id: 5, name: 'Vêtements' },
  't-shirt': { id: 5, name: 'Vêtements' },

  // Animal (ID: 3)
  'dog': { id: 3, name: 'Animal' },
  'cat': { id: 3, name: 'Animal' },
  'hamster': { id: 3, name: 'Animal' },
  'bird': { id: 3, name: 'Animal' },

  // Lunettes (ID: 9)
  'sunglasses': { id: 9, name: 'Lunettes' },
  'eyeglasses': { id: 9, name: 'Lunettes' },

  // Bijoux (ID: 18)
  'necklace': { id: 18, name: 'Bijoux' },
  'bracelet': { id: 18, name: 'Bijoux' },
  'ring': { id: 18, name: 'Bijoux' },
  'earring': { id: 18, name: 'Bijoux' },
  'watch': { id: 18, name: 'Bijoux' },

  // Multimédia (ID: 8)
  'laptop': { id: 8, name: 'Multimédia' },
  'tablet': { id: 8, name: 'Multimédia' },
  'camera': { id: 8, name: 'Multimédia' },
  'headphones': { id: 8, name: 'Multimédia' },

  // Sacs / Bagages (ID: 20)
  'backpack': { id: 20, name: 'Sacs / Bagages' },
  'handbag': { id: 20, name: 'Sacs / Bagages' },
  'purse': { id: 20, name: 'Sacs / Bagages' },
  'suitcase': { id: 20, name: 'Sacs / Bagages' },

  // Papiers d'identité (ID: 22)
  'passport': { id: 22, name: 'Papiers d\'identité' },
  'drivers license': { id: 22, name: 'Papiers d\'identité' },
  'id card': { id: 22, name: 'Papiers d\'identité' },

  // Clés (ID: 16)
  'key': { id: 16, name: 'Clés' },
  'keychain': { id: 16, name: 'Clés' },

  // Carte/CB (ID: 17)
  'credit card': { id: 17, name: 'Carte/CB' },
  'wallet': { id: 17, name: 'Carte/CB' }
};

// Mappings par défaut en cas d'erreur
const defaultMappings = {
  categories: visionToCategoryMapping,
  attributes: {
    // Types de doudous
    '19': { // ID de la catégorie Doudous
      type: {
        'teddy bear': { id: 31, name: 'Nounours' },
        'bear': { id: 31, name: 'Nounours' },
        'stuffed toy': { id: 33, name: 'Peluche' },
        'plush': { id: 33, name: 'Peluche' }
      },
      shape: {
        'bear': { id: 1, name: 'Ours' },
        'teddy bear': { id: 1, name: 'Ours' },
        'animal': { id: 2, name: 'Animal' }
      }
    },
    // Smartphones
    '4': { // ID de la catégorie Smartphone
      brand: {
        'iphone': { id: 10, name: 'Iphone' },
        'samsung': { id: 11, name: 'Samsung' },
        'huawei': { id: 155, name: 'Huawei' }
      }
    },
    // Vêtements
    '5': { // ID de la catégorie Vêtements
      type: {
        'jacket': { id: 47, name: 'Manteau' },
        'shirt': { id: 42, name: 'Chemise' },
        't-shirt': { id: 41, name: 'T-shirt' }
      },
      material: {
        'cotton': { id: 2, name: 'Coton' },
        'wool': { id: 3, name: 'Laine' },
        'leather': { id: 4, name: 'Cuir' }
      }
    }
  }
};

const UploadCard = styled(Card)(({ theme }) => ({
  maxWidth: 400,
  margin: '0 auto',
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  height: 200,
  width: '100%',
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.background.neutral,
  '&:hover': {
    backgroundColor: theme.palette.primary.lighter,
  },
}));

const PreviewImage = styled('img')({
  width: '100%',
  height: 'auto',
  maxHeight: '400px',
  objectFit: 'contain',
  borderRadius: 8,
  backgroundColor: '#f5f5f5',
  padding: '8px'
});

const categoryIcons = {
  'Animal': '/pictos/animal.svg',           // ID: 3
  'Smartphone': '/pictos/smartphone.svg',   // ID: 4
  'Vêtements': '/pictos/vetements.svg',     // ID: 5
  'Multimédia': '/pictos/multimedia.svg',   // ID: 8
  'Lunettes': '/pictos/lunettes.svg',       // ID: 9
  'Clés': '/pictos/clesBadges.svg',         // ID: 16
  'Carte/CB': '/pictos/cb.svg',             // ID: 17
  'Bijoux': '/pictos/bijoux.svg',           // ID: 18
  'Doudous / Peluches': '/pictos/doudous.svg', // ID: 19
  'Sacs / Bagages': '/pictos/sac.svg',      // ID: 20
  'Papiers d\'identité': '/pictos/papiers.svg', // ID: 22
  'Objets divers': '/pictos/divers.svg'     // ID: 23
};

const categoryDisplayNames = {
  'Animal': 'Animal',
  'Smartphone': 'Smartphone',
  'Vêtements': 'Vêtements',
  'Multimédia': 'Multimédia',
  'Lunettes': 'Lunettes',
  'Clés': 'Clés',
  'Carte/CB': 'Carte/CB',
  'Bijoux': 'Bijoux',
  'Doudous / Peluches': 'Doudous / Peluches',
  'Sacs / Bagages': 'Sacs / Bagages',
  'Papiers d\'identité': 'Papiers d\'identité',
  'Objets divers': 'Objets divers'
};

// Déplacer les constantes et fonctions utilitaires dans un objet
const utils = {
  visionToCategoryMapping: {
    // ... existing mapping ...
  },
  
  categoryIcons: {
    // ... existing icons ...
  },
  
  categoryDisplayNames: {
    // ... existing names ...
  },
  
  validateAttribute: (attribute) => {
    if (!attribute) return false;
    if (!attribute.label && !attribute.name) return false;
    if (!Array.isArray(attribute.options)) return false;
    return attribute.options.some(option => option && option.id);
  },
  
  transformAttribute: (attr) => {
    if (!attr || attr.isSecret) return null;
    
    try {
      const attributeId = attr.id || (attr['@id'] ? parseInt(attr['@id'].split('/').pop()) : undefined);
      const options = Array.isArray(attr.attributes) 
        ? attr.attributes
            .filter(option => option && option.id)
            .map((option, index) => ({
              id: option.id || (option.parent ? parseInt(option.parent.split('/').pop()) : index + 1),
              name: option.name || `Option ${index + 1}`,
              value: option.value || '',
              parent: option.parent
            }))
        : [];
      
      return {
        id: attributeId,
        label: attr.uiLabel || attr.name || 'Attribut sans nom',
        ui: attr.ui || 'select',
        isSecret: attr.isSecret || false,
        isRequired: attr.isRequired || false,
        options: options
      };
    } catch (error) {
      console.error('Erreur lors du traitement de l\'attribut:', error);
      return null;
    }
  },
  
  renderAttributes: (categoryAttributes, formAttributes, onAttributeChange) => {
    
    if (!categoryAttributes || typeof categoryAttributes !== 'object') {
      return null;
    }
    
    const validAttributes = Object.entries(categoryAttributes)
      .filter(([key, attribute]) => {
        return utils.validateAttribute(attribute);
      })
      .filter(([_, attribute]) => !attribute.isSecret);
    
    if (validAttributes.length === 0) {
      return null;
    }
    
    return validAttributes.map(([attributeKey, attribute], index) => {
      try {
        const currentAttribute = formAttributes.find(attr => attr.name === attributeKey);
        const currentValue = currentAttribute?.id || '';
        
        
        switch (attribute.ui) {
          case 'select':
            return (
              <FormControl key={`select-${attributeKey}-${index}`} fullWidth sx={{ mb: 2 }}>
                <InputLabel>{attribute.label || attributeKey}</InputLabel>
                <Select
                  value={currentValue}
                  label={attribute.label || attributeKey}
                  onChange={(e) => onAttributeChange(attributeKey, e.target.value)}
                >
                  <MenuItem value="">
                    <em>Sélectionner</em>
                  </MenuItem>
                  {attribute.options
                    .filter(option => option && option.id)
                    .map((option, optionIndex) => (
                      <MenuItem 
                        key={`${attributeKey}-${option.id}-${optionIndex}`}
                        value={option.id}
                      >
                        {option.name || `Option ${optionIndex + 1}`}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            );
            
          case 'colorcheckbox':
            return (
              <FormControl key={`color-${attributeKey}-${index}`} fullWidth sx={{ mb: 2 }}>
                <InputLabel>{attribute.label || attributeKey}</InputLabel>
                <Select
                  value={currentValue}
                  label={attribute.label || attributeKey}
                  onChange={(e) => onAttributeChange(attributeKey, e.target.value)}
                >
                  <MenuItem value="">
                    <em>Sélectionner</em>
                  </MenuItem>
                  {attribute.options
                    .filter(option => option && option.id)
                    .map((option, optionIndex) => (
                      <MenuItem 
                        key={`${attributeKey}-${option.id}-${optionIndex}`}
                        value={option.id}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              borderRadius: 1,
                              backgroundColor: option.value || '#ccc',
                              border: '1px solid',
                              borderColor: 'divider'
                            }}
                          />
                          {option.name || `Option ${optionIndex + 1}`}
                        </Box>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            );
            
          default:

            return null;
        }
      } catch (error) {
        console.error(`Erreur lors du rendu de l'attribut ${attributeKey}:`, error);
        return null;
      }
    });
  }
};

// Composants de la modale
const AnalysisDialog = ({ 
  open, 
  onClose, 
  images, 
  analysisResults, 
  categoryAttributes, 
  formAttributes, 
  isLoadingAttributes,
  onCategoryChange,
  onAttributeChange,
  onApply
}) => {
  const { setFormAttributes } = useContext(AnnonceContext);

  const handleAttributeChange = (attributeName, value) => {
    setFormAttributes(prev => {
      const newAttributes = {
        ...prev,
        [attributeName]: value
      };
      return newAttributes;
    });
  };

  const renderAttributeInput = (attribute) => {
    if (attribute.isSecret) {
      return null;
    }

    switch (attribute.ui) {
      case "select":
        return (
          <FormControl fullWidth key={attribute.id} sx={{ mb: 2 }}>
            <InputLabel>{attribute.name}</InputLabel>
            <Select
              value={formAttributes?.[attribute.name] || ""}
              onChange={(e) => handleAttributeChange(attribute.name, e.target.value)}
              label={attribute.name}
              required={attribute.isRequired}
            >
              {attribute.attributes?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "colorcheckbox":
        return (
          <FormControl fullWidth key={attribute.id} sx={{ mb: 2 }}>
            <InputLabel>{attribute.name}</InputLabel>
            <Select
              value={formAttributes?.[attribute.name] || ""}
              onChange={(e) => handleAttributeChange(attribute.name, e.target.value)}
              label={attribute.name}
              required={attribute.isRequired}
            >
              {attribute.attributes?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: option.value || '#ccc',
                        border: '1px solid #ccc'
                      }}
                    />
                    {option.name}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Résultats de l'analyse
      </DialogTitle>
      <DialogContent>
        {analysisResults && (
          <Stack spacing={2}>
            <ImagePreview images={images} />
            <CategorySelector 
              analysisResults={analysisResults}
              onCategoryChange={onCategoryChange}
            />
            {analysisResults.categoryId && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Attributs
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {categoryAttributes && Object.entries(categoryAttributes).map(([key, attribute]) => {
                    return renderAttributeInput(attribute);
                  })}
                </Box>
              </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
              <Button 
                onClick={onClose}
                variant="outlined"
              >
                Ignorer
              </Button>
              <Button
                onClick={onApply}
                variant="contained"
                endIcon={<CheckCircleIcon />}
              >
                Appliquer
              </Button>
            </Box>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};

const ImagePreview = ({ images }) => {
  if (!images.length) return null;
  
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Photo analysée
      </Typography>
      <Box sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'background.neutral',
        borderRadius: 1,
        overflow: 'hidden'
      }}>
        <img 
          src={images[0].data_url} 
          alt="Analyse" 
          style={{
            maxWidth: '100%',
            maxHeight: '300px',
            objectFit: 'contain'
          }}
        />
      </Box>
    </Paper>
  );
};

const CategorySelector = ({ analysisResults, onCategoryChange }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <FormControl fullWidth>
          <InputLabel>Catégorie</InputLabel>
          <Select
            value={analysisResults.categoryId || ''}
            label="Catégorie"
            onChange={(e) => {
              const selectedCategory = Object.values(visionToCategoryMapping).find(
                cat => cat.id === e.target.value
              );
              if (selectedCategory) {
                onCategoryChange(selectedCategory);
              }
            }}
          >
            {Object.values(visionToCategoryMapping)
              .filter((category, index, self) => 
                index === self.findIndex(c => c.id === category.id)
              )
              .map((category, index) => (
                <MenuItem key={`category-${category.id}-${index}`} value={category.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img 
                      src={categoryIcons[category.name]} 
                      alt={category.name}
                      style={{ width: '24px', height: '24px' }}
                    />
                    {categoryDisplayNames[category.name]}
                  </Box>
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
};

const Upload = () => {
  const [images, setImages] = useState([]);
  const { 
    setImageUpload, 
    setCurrentCategory, 
    setFormAttributes,
    formAttributes 
  } = useContext(AnnonceContext);
  
  const [categories, setCategories] = useState([]);
  const [analysisResults, setAnalysisResults] = useState(null);
  const [analysisError, setAnalysisError] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(false);
  const [categoryAttributes, setCategoryAttributes] = useState({});
  const [isLoadingAttributes, setIsLoadingAttributes] = useState(false);
  const [mappings, setMappings] = useState(defaultMappings);
  const [mappingError, setMappingError] = useState(null);

  // Charger les catégories au montage
  useEffect(() => {
    const loadCategories = async () => {
      try {
  
        const resp = await getCategories();
        
        
        if (!resp || !Array.isArray(resp)) {
          console.error('Format de réponse invalide pour les catégories');
          return;
        }
        
        setCategories(resp);
      } catch (error) {
        console.error('Erreur lors du chargement des catégories:', error);
        notifyErrorEmpty(['Erreur lors du chargement des catégories']);
      }
    };
    
    loadCategories();
  }, []);

  // Fonction pour obtenir le nom de la couleur à partir des valeurs RGB
  const getColorNameFromRGB = (red, green, blue) => {
    const colors = [
      { id: 1, name: 'Rouge', rgb: [255, 0, 0] },
      { id: 2, name: 'Bleu', rgb: [0, 0, 255] },
      { id: 3, name: 'Vert', rgb: [0, 255, 0] },
      { id: 4, name: 'Jaune', rgb: [255, 255, 0] },
      { id: 5, name: 'Noir', rgb: [0, 0, 0] },
      { id: 6, name: 'Blanc', rgb: [255, 255, 255] },
      { id: 7, name: 'Rose', rgb: [255, 192, 203] },
      { id: 8, name: 'Marron', rgb: [139, 69, 19] },
      { id: 9, name: 'Gris', rgb: [128, 128, 128] },
      { id: 10, name: 'Orange', rgb: [255, 165, 0] },
      { id: 11, name: 'Violet', rgb: [128, 0, 128] }
    ];

    let minDistance = Infinity;
    let closestColor = null;

    colors.forEach(color => {
      const distance = Math.sqrt(
        Math.pow(red - color.rgb[0], 2) +
        Math.pow(green - color.rgb[1], 2) +
        Math.pow(blue - color.rgb[2], 2)
      );

      if (distance < minDistance) {
        minDistance = distance;
        closestColor = color;
      }
    });

    return closestColor;
  };

  // Fonction pour normaliser les résultats de l'API Vision
  const normalizeVisionResults = async (responseData) => {


    // Charger les mappings si nécessaire
    if (!mappings || mappingError) {
      try {
  
        const mappingsData = await getMappings();
        
        setMappings(mappingsData);
        setMappingError(null);
      } catch (error) {
        console.error('Erreur lors du chargement des mappings:', error);
        setMappingError(error.message);
        // Utiliser les mappings par défaut en cas d'erreur
        setMappings(defaultMappings);
      }
    }

    const results = {
      category: null,
      categoryId: null,
      type: null,
      typeId: null,
      color: null,
      colorId: null,
      material: null,
      materialId: null,
      features: [],
      featuresIds: [],
      mappedAttributes: {}
    };

    // Utiliser les résultats mappés de l'API
    if (responseData.mappedResults) {
      return responseData.mappedResults;
    }

    // Fallback sur l'ancien système si pas de résultats mappés
    if (responseData.labelAnnotations && mappings) {
      for (const label of responseData.labelAnnotations) {
        const labelName = label.description.toLowerCase();
        
        // Utiliser les mappings de l'API
        if (mappings.categories && mappings.categories[labelName]) {
          const categoryMapping = mappings.categories[labelName];
          results.category = categoryMapping.name;
          results.categoryId = categoryMapping.id;

          // Utiliser les mappings d'attributs spécifiques à la catégorie
          if (mappings.attributes && mappings.attributes[results.categoryId]) {
            const categoryAttributes = mappings.attributes[results.categoryId];
            
            // Mapper les attributs selon leur type
            Object.entries(categoryAttributes).forEach(([attributeType, attributeMapping]) => {
              if (attributeMapping[labelName]) {
                const mappedAttribute = attributeMapping[labelName];
                results[attributeType] = mappedAttribute.name;
                results[`${attributeType}Id`] = mappedAttribute.id;
                results.mappedAttributes[attributeType] = {
                  id: mappedAttribute.id,
                  name: mappedAttribute.name
                };
              }
            });
          }
        }
      }
    }

    // Détecter la couleur dominante
    if (responseData.imagePropertiesAnnotation?.dominantColors?.colors) {
      const dominantColor = responseData.imagePropertiesAnnotation.dominantColors.colors[0];
      if (dominantColor.color) {
        const { red, green, blue } = dominantColor.color;
        const colorName = getColorNameFromRGB(red, green, blue);
        if (colorName) {
          results.color = colorName.name;
          results.colorId = colorName.id;
          results.mappedAttributes.color = {
            id: results.colorId,
            name: results.color
          };
        }
      }
    }

    // Envoyer les résultats à l'API de mapping pour apprentissage
    sendResultsToMappingAPI(results, responseData);

    return results;
  };

  const loadCategoryAttributes = async (categoryId, results) => { 
    try {
      

      // Vérifier si les catégories sont disponibles
      if (!categories || !Array.isArray(categories) || categories.length === 0) {
        console.error('Les catégories ne sont pas encore chargées ou format invalide');
        
        // Utiliser des attributs par défaut pour la catégorie 19 (Doudous)
        if (categoryId === 19) {
          const defaultAttributes = {
            type: {
              id: 1,
              name: 'type',
              uiLabel: 'Type',
              ui: 'select',
              isSecret: false,
              isRequired: true,
              options: [
                { id: 31, name: 'Nounours' },
                { id: 33, name: 'Peluche' }
              ]
            },
            color: {
              id: 2,
              name: 'color',
              uiLabel: 'Couleur',
              ui: 'colorcheckbox',
              isSecret: false,
              isRequired: true,
              options: [
                { id: 1, name: 'Rouge', value: '#FF0000' },
                { id: 2, name: 'Bleu', value: '#0000FF' },
                { id: 3, name: 'Vert', value: '#00FF00' }
              ]
            }
          };
          
          setCategoryAttributes(defaultAttributes);
          setFormAttributes({});
          setIsLoadingAttributes(false);
          
          if (results) {
            applyAnalysisResults(results);
          }
          return;
        }
        
        setCategoryAttributes([]);
        setFormAttributes({});
        setIsLoadingAttributes(false);
        return;
      }

      // Récupérer la catégorie depuis le store
      const category = categories.find(cat => cat.id === categoryId);
      if (!category) {
        console.error('Catégorie non trouvée:', categoryId);
        setCategoryAttributes([]);
        setFormAttributes({});
        setIsLoadingAttributes(false);
        return;
      }

      

      // Utiliser les attributs directement depuis la catégorie de l'API Symfony
      const attributes = category.attribute || [];
      
      // Mettre à jour les attributs dans le state
      setCategoryAttributes(attributes);
      setFormAttributes({});
      setIsLoadingAttributes(false);

      // Si des résultats d'analyse sont fournis, les appliquer
      if (results) {
        applyAnalysisResults(results);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des attributs:', error);
      setCategoryAttributes([]);
      setFormAttributes({});
      setIsLoadingAttributes(false);
    }
  };

  const handleCategoryChange = async (selectedCategory) => {

    
    // Réinitialiser les attributs avant le changement
    setCategoryAttributes({});
    setFormAttributes([]);
    setIsLoadingAttributes(true);
    
    try {
      // Mettre à jour la catégorie dans le contexte
      setCurrentCategory({
        id: selectedCategory.id,
        name: selectedCategory.name,
        attribute: []
      });

      // Mettre à jour les résultats d'analyse
      if (analysisResults) {
        setAnalysisResults(prev => ({
          ...prev,
          category: selectedCategory.name,
          categoryId: selectedCategory.id
        }));
      }

      // Charger les nouveaux attributs avec les résultats d'analyse
      await loadCategoryAttributes(selectedCategory.id, analysisResults);
    } catch (error) {
      console.error('Erreur lors du changement de catégorie:', error);
      notifyErrorEmpty(['Erreur lors du changement de catégorie']);
    } finally {
      setIsLoadingAttributes(false);
    }
  };

  const handleAttributeChange = (attributeKey, value) => {
    const updatedAttributes = formAttributes.filter(attr => attr.name !== attributeKey);
    updatedAttributes.push({
      name: attributeKey,
      id: value,
      value: value,
      label: categoryAttributes[attributeKey]?.label || attributeKey
    });
    
    setFormAttributes(updatedAttributes);
    
    if (analysisResults) {
      setAnalysisResults(prev => ({
        ...prev,
        [attributeKey]: value,
        [`${attributeKey}Id`]: value
      }));
    }
  };

  const applyAnalysisResults = (results) => {
    if (results) {
      // Créer l'objet de données de catégorie
      const categoryData = {
        id: results.categoryId,
        name: results.category,
        attribute: []
      };

      // Ajouter les attributs de base
      if (results.typeId) {
        categoryData.attribute.push({
          name: 'type',
          attributes: [{
            id: results.typeId,
            name: results.type
          }]
        });
      }

      // Ajouter la marque si disponible
      if (results.brandId) {
        categoryData.attribute.push({
          name: 'brand',
          attributes: [{
            id: results.brandId,
            name: results.brand
          }]
        });
      }
      

      setCurrentCategory(categoryData);
      
      // Mise à jour des attributs
      if (results.text) {
        const extractedInfo = {
          type: results.type,
          details: results.text
        };
        setFormAttributes([extractedInfo]);
      }
      
      // Fermer la modale avant d'afficher la notification
      setShowAnalysis(false);
      
      // Attendre un court instant avant d'afficher la notification
      setTimeout(() => {
        notifySuccess('Informations appliquées avec succès !');
      }, 100);
    }
  };

  const handleCloseAnalysis = () => {
    setShowAnalysis(false);
    setAnalysisResults(null);
    setCategoryAttributes({});
    setFormAttributes([]);
  };

  const onChange = (imageList) => {
    setImages(imageList);
    if (imageList.length > 0) {
      setImageUpload(imageList[0].file);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 2 }}>
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={1}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <div className="upload__image-wrapper">
            {imageList.length === 0 ? (
              <UploadButton
                onClick={onImageUpload}
                {...dragProps}
                variant="outlined"
              >
                <AddAPhotoIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                <Typography variant="h6" color="primary">
                  Cliquez ou déposez votre image ici
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Formats acceptés : JPG, PNG
                </Typography>
              </UploadButton>
            ) : (
              <UploadCard>
                <CardMedia>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    backgroundColor: 'background.neutral',
                    p: 2
                  }}>
                    <PreviewImage src={imageList[0].data_url} alt="Preview" />
                  </Box>
                </CardMedia>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                      Image sélectionnée
                    </Typography>
                    <IconButton onClick={onImageRemoveAll} color="error">
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                </CardContent>
              </UploadCard>
            )}
          </div>
        )}
      </ImageUploading>
    </Box>
  );
}

export default Upload;
